import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5e622144")

_pushScopeId("data-v-5e622144")
const _hoisted_1 = {
  key: 0,
  class: "p-fluid p-formgrid p-grid p-m-2"
}
const _hoisted_2 = { class: "p-col-12 p-md-6 p-d-flex p-flex-row p-ai-center" }
const _hoisted_3 = { class: "kn-flex" }
const _hoisted_4 = { class: "p-float-label p-m-2" }
const _hoisted_5 = { class: "kn-material-input-label" }
const _hoisted_6 = { class: "p-d-flex p-flex-row p-jc-between" }
const _hoisted_7 = { class: "calendar-management-input-help p-m-0" }
const _hoisted_8 = { class: "kn-flex" }
const _hoisted_9 = { class: "p-float-label p-m-2" }
const _hoisted_10 = { class: "kn-material-input-label" }
const _hoisted_11 = { class: "p-d-flex p-flex-row p-jc-end" }
const _hoisted_12 = { class: "calendar-management-input-help p-m-0" }
const _hoisted_13 = { class: "p-col-12 p-md-6 p-flex p-d-flex p-ai-center" }
const _hoisted_14 = { class: "kn-flex p-mx-2" }
const _hoisted_15 = { class: "p-float-label" }
const _hoisted_16 = { class: "kn-material-input-label" }
const _hoisted_17 = { class: "kn-flex" }
const _hoisted_18 = { class: "p-float-label" }
const _hoisted_19 = { class: "kn-material-input-label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_Button = _resolveComponent("Button")

  return (_ctx.calendar)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("span", _hoisted_4, [
              _createVNode(_component_InputText, {
                class: ["kn-material-input", {
                            'p-invalid': _ctx.calendarNameDirty && _ctx.calendar.calendar.trim().length === 0
                        }],
                modelValue: _ctx.calendar.calendar,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.calendar.calendar = $event)),
                modelModifiers: { trim: true },
                maxlength: _ctx.calendarManagementDetailFormDescriptor.nameMaxLength,
                disabled: _ctx.readonly,
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.calendarNameDirty = true)),
                onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.calendarNameDirty = true)),
                "data-test": "calendar-name-input"
              }, null, 8, ["modelValue", "maxlength", "class", "disabled"]),
              _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('common.name') + ' *'), 1)
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("div", null, [
                _withDirectives(_createVNode("div", { class: "p-error p-mx-2" }, _toDisplayString(_ctx.$t('common.validation.required', { fieldName: _ctx.$t('common.name') })), 513), [
                  [_vShow, _ctx.calendarNameDirty && _ctx.calendar.calendar.trim().length === 0]
                ])
              ]),
              _createVNode("p", _hoisted_7, _toDisplayString(_ctx.nameHelp), 1)
            ])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("span", _hoisted_9, [
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                modelValue: _ctx.calendar.calType,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.calendar.calType = $event)),
                modelModifiers: { trim: true },
                maxlength: _ctx.calendarManagementDetailFormDescriptor.typeMaxLength,
                disabled: _ctx.readonly,
                "data-test": "calendar-type-input"
              }, null, 8, ["modelValue", "maxlength", "disabled"]),
              _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('common.type')), 1)
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode("p", _hoisted_12, _toDisplayString(_ctx.typeHelp), 1)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode("span", _hoisted_15, [
              _createVNode(_component_Calendar, {
                class: ["calendar-management-detail-form-calendar-input ", {
                            'p-invalid': _ctx.startDateDirty && !_ctx.calendar.calStartDay
                        }],
                modelValue: _ctx.calendar.calStartDay,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.calendar.calStartDay = $event)),
                manualInput: true,
                disabled: _ctx.readonly,
                onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.startDateDirty = true)),
                onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.startDateDirty = true)),
                "data-test": "calendar-start-date-input"
              }, null, 8, ["modelValue", "class", "disabled"]),
              _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('managers.calendarManagement.startValidityDate') + ' *'), 1)
            ])
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("span", _hoisted_18, [
              _createVNode(_component_Calendar, {
                class: ["calendar-management-detail-form-calendar-input", {
                            'p-invalid': _ctx.endDateDirty && !_ctx.calendar.calEndDay
                        }],
                modelValue: _ctx.calendar.calEndDay,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.calendar.calEndDay = $event)),
                manualInput: true,
                minDate: _ctx.calendar.calStartDay,
                disabled: _ctx.readonly,
                onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.endDateDirty = true)),
                onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.endDateDirty = true)),
                "data-test": "calendar-end-date-input"
              }, null, 8, ["modelValue", "class", "minDate", "disabled"]),
              _createVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('managers.calendarManagement.endValidityDate') + ' *'), 1)
            ])
          ]),
          _withDirectives(_createVNode(_component_Button, {
            id: "calendar-management-generate-calendar-button",
            class: "kn-button kn-button--primary p-ml-2",
            disabled: _ctx.generateButtonDisabled,
            onClick: _ctx.generateCalendar
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.generate')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]), [
            [_vShow, _ctx.canManageCalendar && _ctx.generateButtonVisible]
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})